import { createFileRoute } from "@tanstack/react-router";
import { CreateDomain, EditContent } from "@/features/consent-solutions";

const Route = createFileRoute("/_authorized/consent-solutions/$csId/domains/create/")({
  component: () => (
    <EditContent>
      <CreateDomain />
    </EditContent>
  ),
});

export { Route };
